import { render, staticRenderFns } from "./MbscDatePicker.vue?vue&type=template&id=6d3b51c5&scoped=true&"
import script from "./MbscDatePicker.vue?vue&type=script&lang=js&"
export * from "./MbscDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./MbscDatePicker.vue?vue&type=style&index=0&id=6d3b51c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3b51c5",
  null
  
)

export default component.exports
import {QInput,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QIcon})
